import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ApiClientError } from 'api/client';
import { useToast } from 'app/hooks/useToast';
import Logger from 'utils/logger';
import { Dispatch } from 'types/Store';
import { PagesAction } from 'modules/page/pageActions';
import { setPageAutoSchedule } from 'app/modules/posts/api/pageAutoSchedule';

export function usePageAutoScheduleMutation() {
  const { t } = useTranslation();
  const toast = useToast();
  const dispatch = useDispatch<Dispatch>();

  const mutation = useMutation<
    { enabled: boolean },
    ApiClientError,
    { pageId: number; enabled: boolean }
  >(({ pageId, enabled }) => setPageAutoSchedule(pageId, enabled), {
    onSuccess: (data, variables) => {
      dispatch(
        PagesAction.setPageAutoschedule({
          pageId: variables.pageId,
          enabled: data.enabled,
        }),
      );
    },
    onError: (error) => {
      toast(error?.userMessage ?? t('somethingWentWrong'), 'error');
      Logger.error(error);
    },
  });

  return {
    setAutoSchedule: mutation.mutate,
    isUpdating: mutation.isLoading,
  };
}
